import { hasNativeDesktopBridge } from "./desktopRuntime";

export function shouldCheckForDesktopUpdates(
  nativeBridge = hasNativeDesktopBridge(),
  enabled = import.meta.env.VITE_DESKTOP_UPDATER_ENABLED,
): boolean {
  return nativeBridge && enabled === "true";
}
